import { axios } from '@/services/axios';
import { useQuery } from 'hooks/useCustomQuery';

// get service definition for vendor defined service
export default function useGetVendorDefinedTemplate({
    companyID,
    serviceProfile,
    onSuccess,
    onError,
}) {
    return useQuery({
        queryKey: ['vendorDefined', serviceProfile.id],
        queryFn: async () => {
            const res = await axios.get(
                `service/vendordefined/company/${companyID}/Template/${serviceProfile.serviceDefinition.id}`,
            );
            return res.data;
        },
        enabled: Boolean(serviceProfile?.serviceDefinition?.id),
        onSuccess,
        onError,
        refetchOnWindowFocus: false,
    });
}
